'use client';
import { PortableText, PortableTextComponents } from "next-sanity";
import { styles, LocationVariants } from "./Location.css";
import { AppText } from "@otomoro/components/shared/AppText";
import { SanityImage } from "@otomoro/components/shared/SanityImage";
import { AppTitle } from "@otomoro/components/shared/AppTitle";
import { useEffect, useRef } from "react";

interface LocationPopupProps extends LocationVariants {
  country: string
  city: string
  content: any
  thumbnail: any
  location: any
}

export const LocationPopup: React.FC<LocationPopupProps> = ({
  country,
  city,
  content,
  thumbnail,
  location,
}) => {
  const locationRef = useRef(null)

  const contentComponent = {
    block: {
      normal: ({ children }: any) => (
        <AppText as="p" color="black" size="base" className="mt-[0.2rem]"
        >
          {children}
        </AppText>
      ),
    },
    marks: {
      highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
    },
  } as PortableTextComponents

  const setPosition = (): void => {
    if (!locationRef.current) return

    const el = locationRef.current as HTMLElement
    const rightPosition = el.getBoundingClientRect().right
    const screenSize = window.innerWidth

    const diff = screenSize - rightPosition

    if (diff < 0) {
      el.style.transform = `translateX(${diff - 10}px)`
    }
  }

  useEffect(() => {
    setPosition()

    window.addEventListener('resize', setPosition)
    return () => { window.removeEventListener('resize', setPosition) }
  })

  const { locationPopup } = styles()

  return (
    <div className={locationPopup({location})} ref={locationRef}>
      <SanityImage className="w-full h-full object-cover" figureClass="rounded-[0.56rem] md:rounded-m overflow-hidden w-[19rem] aspect-[96/71]" image={thumbnail.image} alt={thumbnail.alt} sizes="35vw" priority={true}/>
      <div className="py-[1.5rem] pr-1 max-w-[25rem]">
        {country &&
          <AppText as="strong" size="small" weight="medium" color="mainPink">{country}</AppText>
        }
        <AppTitle as="h3" variant="h3" color="black" textTransform="uppercase" className="mt-[0.2rem]">{city}</AppTitle>
        <PortableText value={content} components={contentComponent}/>
      </div>
    </div>
  )
}